module.exports = __webpack_public_path__ + "img/payment-en.f1d8b129.svg";